<template>
    <BuilderBase :loading="datasetStore.loading" cssClassContent="content-type-32">
        <template v-slot:section-full>
            <div class="col-12">
                <div class="full-page">
                    <div class="content">
                        <div class="h6">{{ $t('views.dataset_payment_success.title_short')}}</div>
                        <h1 class="h1" v-html="$t('views.dataset_payment_success.title')"></h1>
                        <p class="p" v-if="datasetStore.order?.download_url">{{ $t('views.dataset_payment_success.description')}}</p>
                        <p class="p" v-else>{{ $t('views.dataset_payment_success.description_alt')}}</p>
                        <div class="buttons">
                            <a class="btn-1 btn-m-icon" target="_blank" rel="noopener" v-if="datasetStore.order?.download_url" :href="datasetStore.order.download_url">
                                <div class="icon-download-neg"></div>
                                <span>{{ $t('components.builderBottomNav.buttons.download_dataset')}}</span>
                            </a>

                            <div class="btn-5 btn-m-icon" @click="resetDataset">
                                <span>{{ $t('components.builderBottomNav.buttons.reset_dataset')}}</span>
                                <div class="icon-arrow-pos"></div>
                            </div>
                        </div>
                        <p class="p notice" v-html="$t('views.dataset_payment_success.notice')"></p>
                    </div>
                </div>
            </div>
        </template>
    </BuilderBase>
</template>

<script>
    import i18nViewMixin from '@/mixins/i18nViewMixin';
    import { useDatasetStore } from '@/stores/dataset';
    import BuilderBase from '@/views/builder/BuilderBase';
    import { scrollToTop } from '@/utils/scroll';
    import { gaBuilderPayment } from '@/utils/analytics/builder';

    export default {
        name: 'HomeView',
        mixins: [i18nViewMixin],
        components: {
            BuilderBase
        },
        props: {
            order_id: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                seo_title: 'views.dataset_payment_success.seo_title'
            };
        },
        computed: {
            datasetStore() {
                return useDatasetStore();
            }
        },
        methods: {
            resetDataset() {
                this.datasetStore.resetDataset();
                this.$router.push({ name: 'builder' });
            }
        },
        async mounted() {
            scrollToTop();

            if(this.order_id) {
                await this.datasetStore.fetchOrder(this.order_id);

                if(!this.datasetStore.order.status) {
                    this.$router.push({ name: 'builder' });
                } else if(this.datasetStore.order.status !== 'paid') {
                    this.$router.push({ name: 'payment-failed', query: { order_id: this.order_id } });
                } else {
                    gaBuilderPayment(true, this.datasetStore.order.count || null, this.datasetStore.order.price || null, this.order_id || null, this.datasetStore.order?.query || null);
                }
            } else {
                this.$router.push({ name: 'builder' });
            }
        }
    }
</script>